import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { ConfigServiceService } from '../../services/config-service.service';
import { BlogSectionService } from '../../services/blog-section.service';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { CustomFlexLayoutModule } from '../../flex-layout/custom-flex-layout.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { BlogLayoutComponent } from '../blog-layout/blog-layout.component';
import { DefaultLayoutDirective } from '../../flex-layout/custom-layout';
import { DefaultLayoutAlignDirective } from '../../flex-layout/custom-layout-align';
import { DefaultLayoutGapDirective } from '../../flex-layout/custom-layout-gap';
import { DefaultFlexDirective } from '../../flex-layout/flex';
import { DefaultShowHideDirective } from '../../flex-layout/show-hide';
import { DefaultClassDirective } from '../../flex-layout/class';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@Component({
  selector: 'calsoft-blog-section',
  imports: [DefaultClassDirective, MatProgressSpinnerModule, NgxPaginationModule, InfiniteScrollDirective, CustomFlexLayoutModule, MatIconModule, MatButtonModule, BlogLayoutComponent, DefaultLayoutDirective, DefaultLayoutAlignDirective, DefaultLayoutGapDirective, DefaultFlexDirective, DefaultShowHideDirective, BlogLayoutComponent],
  templateUrl: './blog-section.component.html',
  styleUrl: './blog-section.component.scss'
})
export class BlogSectionComponent {

  isEmpty: any = false;
  public categoryProducts: any = [];
  public count: any;
  spinnerMain: boolean = false;
  otherProductType: boolean = false;
  @Input() data: any;
  list: any = [];
  blogType = 1;
  public viewCol: number = 25;
  counts: any = [12];
  public page: number = 0;
  mobileSize: number = 4;
  size: any = this.counts[0];

  spinner: boolean = false;
  search: any = "";

  public sortings = [

    { value: "pageId,DESC", viewValue: "Newest First" },
  ];
  filterMap = new Map<any, any>();
  paths: any = [];
  sortParam: any = this.sortings[0].value;
  mobileScreen: boolean = false;

  public sort: string = this.sortings[0].viewValue;
  blogSize: any;
  previousPage: any = 0;
  noProductValue: boolean = false;
  fullConfigData: any;
  fullBlogData: any;


  constructor(private blogSectionService: BlogSectionService,
    private configService: ConfigServiceService,
    private cdRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    const blogData = JSON.parse(localStorage.getItem('BlogMainType') || '{}');
    this.fullBlogData = blogData;
    const configData = JSON.parse(localStorage.getItem('GetConfigData') || '{}');
    this.fullConfigData = configData;
    this.spinnerMain = true;

    this.blogSize = this.data['blogSize'];
    this.viewCol = 100 / this.blogSize;

    if (window.innerWidth < 1000) {
      this.mobileScreen = true;
    } else {
      this.mobileScreen = false;
    }

    this.getBlogPage();
    this.getConfigData();
  }



  pageSize: any;
  config: any = {};
   getBlogPage() {
  this.spinnerMain = true; 
  this.blogSectionService.getBlogPage(this.page, this.size, this.sortParam).subscribe(
    (res: any) => {
      this.list = res['content'];
      this.count = res["totalElements"];
      this.isEmpty = res["empty"];
      this.pageSize = res["totalPages"];

      this.config = {
        currentPage: this.page,
        totalItems: this.count,
        itemsPerPage: this.size
      };

      this.getcount();
      this.spinnerMain = false;
      this.cdRef.detectChanges(); 
    },
    () => {
      this.spinnerMain = false;
    }
  );
}

  getConfigData() {
    let data = this.fullConfigData;

    this.blogType = data['blogPageType'] || 1;

  }


  getcount() {


  }



  public onPageChanged(event: any) {

    this.page = event - 1;
    this.getBlogPage();


    this.page = event
    this.config = {
      itemsPerPage: this.size,
      currentPage: this.page,
      totalItems: this.count,
    };

    this.previousPage = event;



  }

  public onScroll() {
    if (window.innerWidth < 850 && this.page < this.pageSize) {
      this.page++;

      this.spinner = true;
      if (this.list.length < this.count) {

        this.blogSectionService.getBlogPage(
          this.page,
          this.mobileSize,
          this.sortParam
        )
          .subscribe((res: any) => {
            this.spinner = false;
            this.list = [...this.list, ...res['content']];

          });

      } else {
        this.spinner = false;
        //this.noProduct();
        this.noProductValue = true;
      }
    }
  }




}
